import { render, staticRenderFns } from "./orderhistorydetail.vue?vue&type=template&id=55d92477&"
import script from "./orderhistorydetail.vue?vue&type=script&lang=js&"
export * from "./orderhistorydetail.vue?vue&type=script&lang=js&"
import style0 from "./orderhistorydetail.vue?vue&type=style&index=0&id=55d92477&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports